<mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
    <mat-tab label="{{ 'General.Details' | translate }}">
        <mat-card appearance="outlined" class="mat-elevation-z4">
            <mat-card-content>
                <div class="container ml-0">
                    <h2 class="summary">{{ 'User.User' | translate }}</h2>
                    <div class="row">
                        <div class="col-12">
                            <div class="row">
                                <div class="col-12 col-lg-3">
                                    {{ 'User.Username' | translate }}
                                </div>
                                <div class="col-12 col-lg-3">
                                    <b>{{ usernameOrEMail }}</b>
                                </div>
                            </div>
                            <div class="row mt-3 mt-lg-0">
                                <div class="col-12 col-lg-3">
                                    {{ 'Login.Password' | translate }}
                                </div>
                                <div class="col-12 col-lg-3">
                                    @if (isAirlockEnabled) {
                                        <a href="/auth/ui/app/protected/select/flow/password-change">
                                            {{ 'User.ChangePassword' | translate }}
                                        </a>
                                    } @else {
                                        <a href="javascript:void(0)" (click)="openPasswordModal()">
                                            {{ 'User.ChangePassword' | translate }}
                                        </a>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
    </mat-tab>
</mat-tab-group>
